import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Collapse, Stack } from "@mui/material";
export const MyMealsNavDrawerMenu = ({ M, children }) => {
    return (_jsx(Collapse, Object.assign({ in: M.isMyMealsNavDrawerMenuOpen, timeout: "auto", unmountOnExit: true, sx: { borderBottom: "1px solid lightGrey" } }, { children: _jsx(Stack, Object.assign({ sx: (theme) => ({
                maxHeight: 300,
                overflowY: "auto",
                backgroundColor: alpha(theme.palette.primary.light, 0.1),
                "&:hover": {
                    backgroundColor: alpha(theme.palette.primary.light, 0.1),
                },
            }) }, { children: children })) })));
};
